// General
export const SET_ERROR = "SET_ERROR"
export const SET_APP_INFO = "SET_APP_INFO"

// Database
export const LOADING_STATE = "LOADING_STATE"
export const SET_RAINFALLFORECAST = "SET_RAINFALLFORECAST"
export const SET_SCHEDULED_NOTIFICATIONS = "SET_SCHEDULED_NOTIFICATIONS"

// Firebase 
export const SET_AUTH_USER = "SET_AUTH_USER"
export const SET_SUBSCRIPTION = "SET_SUBSCRIPTION"
